import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getIsLoggedIn } from '@api/selectors/auth';
import useDoubtConfig from '@api/hooks/goal/custom-doubts/useDoubtConfig';
import RecentDoubts from './RecentDoubts';
import AadUploadImage from './AadUploadImage';

const AskADoubt = ({ goalUID }) => {
  const {
    doubtConfigData: { allowedToAskNewDoubt, isAiDoubtsEnabled }
  } = useDoubtConfig(goalUID);
  const isLoggedIn = useMyInfo(getIsLoggedIn);

  const showDoubts = allowedToAskNewDoubt || !isLoggedIn;
  const showAiDoubts = isAiDoubtsEnabled || !isLoggedIn;
  return (
    <>
      <AadUploadImage
        goalUID={goalUID}
        showDoubts={showDoubts}
        showAiDoubts={showAiDoubts}
      />

      <RecentDoubts goalUID={goalUID} />
    </>
  );
};

export default AskADoubt;
